import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import ToggleDisplay from 'react-toggle-display';
import { Grid, Dropdown, Modal, Button } from 'semantic-ui-react';

import { GroupListBtn, StaffListAdd, TransferingList, RequestedList } from 'components/StaffSignUp';
import { LoadingBar } from 'components/Commons';
import { GroupList } from 'components/SikdaePolicy';

import * as cm_action from 'actions/commons';
import * as com_action from 'actions/company';
import cm from 'helpers/commons';
import toastr from 'helpers/toastr';

class StaffSignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupNum: null,
      groupName: '',

      totalList: 0,
      invalid: null,

      sendPhone: null,
      sendEmail: null //,

      //page : 1
    };
  }

  async componentWillMount() {
    const { comAPI } = this.props;

    //step 1. 식대그룹 리스트
    await this.sikdaeGroupList();
    //회원가입 요청내역 상태리스트
    //await comAPI.signupStatus();
    //회원가입 요청 내역
    //await this.requestedListSel();
  }

  componentDidMount() {
    cm.mainTitle('사용자 회원가입 관리');
  }

  dataDelete = () => {
    this.setState({
      sendPhone: null,
      sendEmail: null
    });
  };

  //사용자 직접 추가
  DirectlyMemberAdd = () => {
    this.context.router.history.push('/main/staffInfo/join/new');
  };

  //식대 그룹 조회
  sikdaeGroupList = async () => {
    const { cmAPI, sikdaeGroup } = this.props;
    const params = { viewType: 'all' };

    try {
      await cmAPI.sikdaeGroupList(params);
      const { sikdaeGroup } = this.props;

      //식대그룹이 있을 시 default 정책 조회
      // if(sikdaeGroup) {
      //
      //   let idx = sikdaeGroup.data.group[0].idx;
      //   let name = sikdaeGroup.data.group[0].name;
      //
      //   //첫 화면 진입 시 식대정책 조회
      //   this.sikdaeGroupClick(idx, name);
      // }
    } catch (e) {
      console.log('###### sikdaeGroup : ', e);
      const { response } = e;
      if (response && response.data) {
        toastr('top-right', 'error', response.data.message);
      }
    }
    // 조회 실패(reject·errorBind) 시 sikdaeGroup이 비어 로딩바가 안 꺼지므로 실패 표시
    const { sikdaeGroup: loaded } = this.props;
    if (!loaded) this.setState({ groupFailed: true });
  };

  //식대 그쿱 클릭
  sikdaeGroupClick = (group, name) => {
    this.setState({
      groupNum: group,
      groupName: name
    });
  };

  /**
   * [ 회원 등록 리스트 데이터 유효성 체크]
   * @param  {[array]} info [ 회원 가입 정보 ]
   * @return {[array]}      [ email, phone, allInfo(유효성 체크 후 정상 데이터), wasteInfo(잘못된 데이터)]
   */
  userInfoDataCheck = (info) => {
    let email = [];
    let phone = [];
    let allInfo = [];
    let wasteInfo = [];
    let overlap = [];

    for (let i = 0; i < info.length; i++) {
      //공백제거
      let data = info[i].replace(/(\s*)/g, '');
      //이메일과 휴대전화번호 분리
      if (data.indexOf('@') != -1) {
        //이메일 데이터 유효성 체크
        if (cm.validateEmail(data)) {
          //데이터 중복 제거
          if (email.indexOf(data) === -1) {
            email.push(data);
          } else {
            overlap.push(data);
          }
          allInfo.push(data);
        } else {
          wasteInfo.push(data);
          info.splice(i, 1);
          --i;
        }
      } else {
        //전화번호 데이터 유효성 체크
        if (cm.validatePhone(data) || cm.validatePhone2(data)) {
          let replaceDate = data.replace(/-/gi, '');
          //데이터 중복제거
          if (phone.indexOf(replaceDate) === -1) {
            phone.push(replaceDate);
          } else {
            overlap.push(data);
          }
          allInfo.push(replaceDate);
        } else {
          wasteInfo.push(data);
          info.splice(i, 1);
          --i;
        }
      }
    }

    const result = {
      email: email,
      phone: phone,
      info: info,
      allInfo: allInfo,
      wasteInfo: wasteInfo,
      overlap: overlap
    };

    return result;
  };

  //이메일, 휴대폰 분류
  devideStaffList = () => {
    const { groupNum } = this.state;

    if (!groupNum) {
      toastr('top-right', 'warning', '식대그룹을 선택하세요.');
      return;
    }
    let arr = [];

    $.each(
      $('.txtInput')
        .val()
        .split('\n'),
      function(i, name) {
        if (name != '') {
          arr.push(name);
        }
      }
    );

    this.setState({ totalList: arr.length });
    let oArray = this.userInfoDataCheck(arr);

    const params = {
      phone: oArray.phone.length > 0 ? oArray.phone : null,
      email: oArray.email.length > 0 ? oArray.email : null
    };

    let invalid = [];

    oArray.overlap.forEach((data) => {
      invalid.push({
        value: data,
        type: '',
        reason: '중복 입력'
      });
    });

    oArray.wasteInfo.forEach((data) => {
      invalid.push({
        value: data,
        type: '',
        reason: '형식오류'
      });
    });

    this.checkValid(params, invalid);
  };

  //사용자 회원가입 목록 추가
  checkValid = async (validValue, inparams) => {
    const { comAPI, check } = this.props;
    const params = {
      check: {
        phone: validValue.phone,
        email: validValue.email
      }
    };

    await comAPI.checkStaffList(params);

    //미전송 데이터 분류
    const { invalid } = this.props.checkStaff.data.check;

    invalid.forEach((data) => {
      inparams.push(data);
    });

    this.setState({ invalid: inparams });

    //링크 전송 데이터 분류
    const { valid } = this.props.checkStaff.data.check;

    let phone = [],
      email = [];

    valid.forEach(function(val) {
      if (val.type === 'phone') {
        phone.push(val.value);
      } else if (val.type === 'email') {
        email.push(val.value);
      }
    });

    this.setState({
      sendPhone: phone,
      sendEmail: email
    });
  };

  initialInvalid = () => {
    this.setState({
      invalid: null,
      totalList: 0
    });
  };

  //회원가입 링크 전송
  staffLinkAdd = async () => {
    if (!cm.valueCheck(this.state.sendPhone) || !cm.valueCheck(this.state.sendEmail)) {
      const params = {
        send: {
          phone: this.state.sendPhone,
          email: this.state.sendEmail,
          groupidx: this.state.groupNum
        }
      };

      try {
        const { comAPI, staffLink } = this.props;

        await comAPI.staffLinkAdd(params);
        window.location.reload();
      } catch (e) {
        let response = e.response;
        if (response) {
          toastr('top-right', 'error', response.data.message);
        }

        console.log('#### staffLinkAdd : ' + e);
      } finally {
        this.setState({
          sendPhone: null,
          sendEmail: null
        });
      }
    }
  };

  render() {
    const { groupNum, groupName, invalid, totalList, groupFailed } = this.state,
      { sikdaeGroup, status, reqList } = this.props,
      GroupListFn = {
        sikdaeGroup: sikdaeGroup,
        sikdaeGroupClick: this.sikdaeGroupClick,
        groupNum: groupNum
      },
      StaffListFn = {
        devideStaffList: this.devideStaffList,
        initialInvalid: this.initialInvalid,
        invalid: invalid,
        totalList: totalList,
        dataDelete: this.dataDelete
      },
      TransferingFn = {
        staffLinkAdd: this.staffLinkAdd
      },
      RequestedListFn = {
        groupNum: groupNum //,
        // requestedListSel : this.requestedListSel,
        // pageClick        : this.pageClick
      };

    let loading = '';
    if (!((sikdaeGroup || groupFailed) && status && reqList)) {
      $('.staff-signup').scrollTop(0);
      loading = <LoadingBar />;
    }

    return (
      <main className="staff-signup">
        <div className="top-btn button">
          <Button.Group>
            <Button inverted color="green" onClick={this.DirectlyMemberAdd} content="사용자 직접 추가" />
          </Button.Group>
        </div>
        {loading}

        <div className="comment-box">
          <div className="comments">
            * Step 1 &gt; 2 &gt; 3 순서로 진행해주세요.
            <br />
            * Step 2 에서 입력한 휴대전화번호나 이메일 주소로 개인별 회원가입 링크가 전송됩니다.
            <br />
            * Step 1 에서 사용자가 지급받을 식대 그룹을 지정해 주세요. 식대그룹은 사용자 관리에서 변경할 수 있습니다.
            <br />
          </div>
        </div>

        <Grid className="join-boxs">
          <Grid.Column width={3}>
            <div className="group-box sikdae-group">
              {/* <GroupList GroupListFn={GroupListFn}/> */}
              <GroupListBtn GroupListFn={GroupListFn} />
            </div>
          </Grid.Column>
          <Grid.Column width={10}>
            <div className="group-box fill-link">
              <StaffListAdd StaffListFn={StaffListFn} />
            </div>
          </Grid.Column>
          <Grid.Column width={3}>
            <div className="group-box trans-list">
              <TransferingList TransferingFn={TransferingFn} />
            </div>
          </Grid.Column>
        </Grid>

        <RequestedList RequestedListFn={RequestedListFn} />
      </main>
    );
  }
}

StaffSignUp.contextTypes = {
  router: PropTypes.object.isRequired
};

StaffSignUp = connect(
  (state) => ({
    sikdaeGroup: state.commons.sikdaeGroup,
    checkStaff: state.company.check,
    staffLink: state.company.link,
    status: state.company.data,
    reqList: state.company.requested
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        sikdaeGroupList: cm_action.SikdaeGroupList
      },
      dispatch
    ),

    comAPI: bindActionCreators(
      {
        signupStatus: com_action.SignupStatus,
        checkStaffList: com_action.CheckStaffList,
        staffLinkAdd: com_action.StaffLinkAdd,
        requestList: com_action.RequestedList,
        resendLink: com_action.ResendLink
      },
      dispatch
    )
  })
)(StaffSignUp);

export default StaffSignUp;
